/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

/**
 * Available AWS regions
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Region = exports.Region = function () {
  function Region() {
    _classCallCheck(this, Region);
  }

  _createClass(Region, null, [{
    key: 'exists',


    /**
     * @param {String} name
     * @returns {Boolean}
     */
    value: function exists(name) {
      return name === '' || -1 !== Region.list().indexOf(name);
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'list',
    value: function list() {
      return [Region.ANY, Region.AP_NORTHEAST_TOKYO, Region.AP_NORTHEAST_SEOUL, Region.AP_SOUTHEAST_SYDNEY, Region.AP_SOUTHEAST_SINGAPORE, Region.AP_SOUTH_MUMBAI, Region.EU_CENTRAL_FRANKFURT, Region.EU_WEST_IRELAND, Region.EU_WEST_LONDON, Region.SA_EAST_SAO_PAULO, Region.CA_CENTRAL_MONTREAL, Region.US_EAST_VIRGINIA, Region.US_EAST_OHIO, Region.US_WEST_CALIFORNIA, Region.US_WEST_OREGON];
    }

    /**
     * List method alias
     *
     * @returns {String[]}
     */

  }, {
    key: 'all',
    value: function all() {
      return Region.list();
    }

    /**
     * @param {string} defaultRegion
     * @param {array} availableRegions
     * @returns {string}
     */

  }, {
    key: 'getAppropriateAwsRegion',
    value: function getAppropriateAwsRegion(defaultRegion, availableRegions) {
      if (availableRegions.indexOf(defaultRegion) !== -1) {
        return defaultRegion;
      }

      let regionContinent = defaultRegion.split('-')[0];

      for (let regionKey in availableRegions) {
        if (!availableRegions.hasOwnProperty(regionKey)) {
          continue;
        }

        let region = availableRegions[regionKey];

        if (region === Region.ANY) {
          return defaultRegion;
        }

        if (region.split('-')[0] === regionContinent) {
          return region;
        }
      }

      return availableRegions[0]; // fallback to first available region
    }

    /**
     *
     * @param {String} region
     * @returns {String}
     */

  }, {
    key: 'getRegionPrefix',
    value: function getRegionPrefix(region) {
      let prefix = null;

      switch (region) {
        case Region.CA_CENTRAL_MONTREAL:
        case Region.US_EAST_OHIO:
        case Region.AP_SOUTH_MUMBAI:
        case Region.AP_NORTHEAST_SEOUL:
        case Region.EU_CENTRAL_FRANKFURT:
        case Region.EU_WEST_LONDON:
          prefix = '.';
          break;
        case Region.US_EAST_VIRGINIA:
        case Region.US_WEST_CALIFORNIA:
        case Region.US_WEST_OREGON:
        case Region.AP_SOUTHEAST_SINGAPORE:
        case Region.AP_SOUTHEAST_SYDNEY:
        case Region.AP_NORTHEAST_TOKYO:
        case Region.EU_WEST_IRELAND:
        case Region.SA_EAST_SAO_PAULO:
          prefix = '-';
          break;
        default:
          console.warn(`No s3 website endpoint format specified for ${region}. Fallback to '-' separator.`);
          prefix = '-';
      }

      return prefix;
    }
  }, {
    key: 'ANY',

    /**
     * @returns {String}
     */
    get: function get() {
      return '*';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'AP_NORTHEAST_TOKYO',
    get: function get() {
      return 'ap-northeast-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'AP_NORTHEAST_SEOUL',
    get: function get() {
      return 'ap-northeast-2';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'AP_SOUTHEAST_SINGAPORE',
    get: function get() {
      return 'ap-southeast-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'AP_SOUTHEAST_SYDNEY',
    get: function get() {
      return 'ap-southeast-2';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'AP_SOUTH_MUMBAI',
    get: function get() {
      return 'ap-south-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'EU_CENTRAL_FRANKFURT',
    get: function get() {
      return 'eu-central-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'EU_WEST_IRELAND',
    get: function get() {
      return 'eu-west-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'EU_WEST_LONDON',
    get: function get() {
      return 'eu-west-2';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'SA_EAST_SAO_PAULO',
    get: function get() {
      return 'sa-east-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CA_CENTRAL_MONTREAL',
    get: function get() {
      return 'ca-central-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'US_EAST_VIRGINIA',
    get: function get() {
      return 'us-east-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'US_EAST_OHIO',
    get: function get() {
      return 'us-east-2';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'US_WEST_CALIFORNIA',
    get: function get() {
      return 'us-west-1';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'US_WEST_OREGON',
    get: function get() {
      return 'us-west-2';
    }
  }]);

  return Region;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Region.js
// module id = 165
// module chunks = 0